//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required } from 'vuelidate/lib/validators';
import AiToolsMixin from '@motionelements/core/src/components/mixins/ai-tools.mixin.js';
import PredictionMixin from '@/components/mixins/prediction.mixin.js';
import useMarketplaceProductsMixin from '@/components/mixins/use-marketplace-products.mixin.js';

export default {
  name: 'FaceSwap',
  mixins: [AiToolsMixin, PredictionMixin, useMarketplaceProductsMixin],
  components: {
    ToolImageLayout: () => import('@/components/core/ToolImageLayout.vue'),
    SourceImage: () => import('@/components/tools/SourceImage.vue'),
    DemoSourceImages: () => import('@/components/tools/DemoSourceImages.vue'),
  },
  data() {
    return {
      form: {
        model: 'image_face_swap',
        image: null,
        targetImage: null,
      },
      demoImage: null,
      demoFace: 'original',
      prediction: {
        model: 'image_face_swap',
        image: null,
        targetImage: null,
      },
      demoImages: [
        {
          labelImage: 'https://static.moele.me/img/studio-ai/face_swap/source-image/european-woman-brown.jpg?auto=format&w=88',
          value: 'brown',
        },
        {
          labelImage: 'https://static.moele.me/img/studio-ai/face_swap/source-image/european-woman-blue.jpg?auto=format&w=88',
          value: 'blue',
        },
        {
          labelImage: 'https://static.moele.me/img/studio-ai/face_swap/source-image/asian-woman.jpg?auto=format&w=88',
          value: 'orange',
        },
      ],
      demoFaces: [
        {
          labelImage: 'https://static.moele.me/img/studio-ai/face_swap/face/asian-face.jpg?auto=format&w=88',
          value: 'asian-face',
        },
        {
          labelImage: 'https://static.moele.me/img/studio-ai/face_swap/face/european-face-blonde.jpg?auto=format&w=88',
          value: 'euro-face',
        },
        {
          labelImage: 'https://static.moele.me/img/studio-ai/face_swap/face/european-face-brunete.jpg?auto=format&w=88',
          value: 'arabic-face',
        },
      ],
    };
  },
  validations: {
    form: {
      image: {
        required: required,
      },
      targetImage: {
        required: required,
      },
    },
  },
  computed: {
    tool() {
      return this.aiTools.find(({ id }) => id === this.aiToolsIds.FACE_SWAP);
    },
    demoOutput() {
      if (this.demoImage && this.demoFace) {
        return [{ preview: { url: `https://static.moele.me/img/studio-ai/${this.aiToolsIds.FACE_SWAP}/output/${this.demoImage}_${this.demoFace}.png?auto=format&w=524` } }];
      }
      return null;
    },
  },
  methods: {
    clearForm() {
      this.form.image = null;
      this.form.targetImage = null;
    },
    setFormFromResponse(response) {
      this.form.image = _.get(response, 'prediction.input.inputImage');
      this.form.targetImage = _.get(response, 'prediction.input.targetImage');
      this.prediction.image = _.get(response, 'prediction.input.inputImage');
      this.prediction.targetImage = _.get(response, 'prediction.input.targetImage');
    },
  },
};
